<template>
	<div class="modal-box error-popup" @click.self="onClickClose">
		<div class="modal-content">
			<h1>{{ title }}</h1>
			<p>{{ text }}</p>
			<button class="btn btn-primary btn-round" @click="onClickClose">OK</button>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'title',
		'text'
	],
	methods: {
		onClickClose () {
			this.$emit('close')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/boxes/ErrorPopUp.vue